import(/* webpackMode: "eager" */ "/codebuild/output/src2515735204/src/apps/teo/app/(protected)/page.tsx")